import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Input, Tooltip } from 'antd';
import { DownOutlined, CheckOutlined } from '@ant-design/icons';
import { URL } from '../../helper/Mainurl';

const ColorDropdownWithName = ({
  value,
  name,
  onColorChange,
  onNameChange,
  otherParentColor,
  usedColors = [],
  placeholder = "Enter Nickname"
}) => {
  const token = localStorage.getItem('authToken');
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [colorOptions, setColorOptions] = useState([]);
  const getCoparentMetaData = async () => {
    try {
      const response = await fetch(`${URL}/v1/co-parenting/metadata`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.code === 200) {
        const { colors } = data.data;
        if (Array.isArray(colors)) {
          const mapped = colors.map((color) => ({
            id: color.id,
            label_name: color.value,
          }));
          setColorOptions(mapped);
        }
      } else {
        console.error('Invalid response from server:', data);
      }
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  useEffect(() => {
    getCoparentMetaData();
  }, []);
  const colorMenu = (
    <div style={{ display: 'flex', gap: 10, padding: 8, flexWrap: 'wrap' }}>
      {colorOptions.map((colorObj) => {
        const isUsed = usedColors.includes(colorObj.label_name);
        const isCurrent = value?.id === colorObj.id;
        const isOtherParent = otherParentColor?.id === colorObj.id;
        const disabled = !isCurrent && (isUsed || isOtherParent);

        return (
          <Tooltip
            title={disabled ? 'Color already used' : ''}
            key={colorObj.id}
          >
            <div
              onClick={() => {
                if (!disabled) {
                  onColorChange({ id: colorObj.id, name: colorObj.label_name });
                  setOpen(false);
                }
              }}
              style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: colorObj.label_name,
                border: '2px solid white',
                cursor: disabled ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: isCurrent ? '0 0 0 2px #9A4FE0' : 'none',
                opacity: disabled ? 0.4 : 1,
              }}
            >
              {isCurrent && (
                <CheckOutlined style={{ color: 'white', fontSize: 10 }} />
              )}
            </div>
          </Tooltip>
        );
      })}
    </div>
  );

  return (
    <div
      ref={dropdownRef}
      className="color-name-dropdown"
      style={{
        border: open ? '1px solid #9A4FE0' : '1px solid #d9d9d9',
        borderRadius: 10,
        padding: '15px 8px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'default',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          borderRadius: '50%',
          backgroundColor:  value  &&  (value?.name || value?.value || '#ccc'),
          border: '1px solid #ccc',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />

      <Dropdown
        overlay={colorMenu}
        trigger={['click']}
        open={open}
        onOpenChange={setOpen}
        placement="bottomLeft"
        getPopupContainer={() => dropdownRef.current}
      >
        <div onClick={() => setOpen(!open)} style={{ display: 'flex', alignItems: 'center' }}>
          <DownOutlined style={{ color: '#9A4FE0', fontSize: 12, cursor: 'pointer' }} />
        </div>
      </Dropdown>

      <Input
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        bordered={false}
        style={{ flex: 1, padding: 0 }}
        onClick={(e) => e.stopPropagation()}
        placeholder={placeholder}
      />
    </div>
  );
};

export default ColorDropdownWithName;
